import { render, staticRenderFns } from "./ot-invitation-accept.vue?vue&type=template&id=640a137c&scoped=true&"
import script from "./ot-invitation-accept.vue?vue&type=script&lang=ts&"
export * from "./ot-invitation-accept.vue?vue&type=script&lang=ts&"
import style0 from "./ot-invitation-accept.vue?vue&type=style&index=0&id=640a137c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a137c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAlert,VDivider,VOverlay})
